import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { StoreService } from "../services/store.service";

@Injectable()
export class AuthGuard {
    constructor(
        private router: Router,
        private storeService: StoreService
    ) {}
    canActivate(): boolean {
        let token = this.storeService.get("token");

        if (token && token !== "null" && token !== "undefined") {
            return true;
        } else {
            this.router.navigate(["/auth/login"]);
            return true;
        }
    }
}
